import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import COLOR_MAP from '../../../../constants/color-mapping';
import PopoverInfoIcon from '../../../../components/PopoverInfoIcon/PopoverInfoIcon';
import InfoUnavailable from '../../../../components/common/InfoUnavailable';

const excretionEffectInfo = {
  Excreted: '',
  'Not excreted': '',
  Unknown: '',
};
const LactationPrecautions = forwardRef(function (
  { lactationPrecautions },
  ref,
) {
  return (
    <div
      ref={ref}
      className="mb-36 scroll-offset"
      id="lactation-precautions-section"
    >
      <h4 className="accordion-header">Lactation Precautions</h4>

      <div className="accordion-body">
        {lactationPrecautions?.Lactation_Precautions?.length ? (
          <div>
            <ul className="indicator">
              {lactationPrecautions.Lactation_Precautions.map(
                (lactationPrecaution, index) => (
                  <div key={`lactation-precaution-${index}`}>
                    <li className="f-18 font-semibold">
                      {lactationPrecaution.PrecautionsLactationDesc}
                    </li>
                    <div className="">
                      <div className="row">
                        <div className=" col-sm-6 col-12 drug-info">
                          <label>
                            Severity Description
                            <PopoverInfoIcon
                              popoverInfo={COLOR_MAP.LactationPrecautions}
                            />
                          </label>
                          <p>
                            <span
                              className={
                                COLOR_MAP.LactationPrecautions[
                                  lactationPrecaution.SeverityDesc
                                ]
                              }
                            />
                            {lactationPrecaution.SeverityDesc}
                          </p>
                        </div>
                        <div className=" col-sm-6 col-12 drug-info">
                          <label>
                            Excretion Effect
                            <PopoverInfoIcon
                              headerContent={'Excretion Effect'}
                              popoverInfo={excretionEffectInfo}
                            />
                          </label>
                          <p>{lactationPrecaution.ExcretionEffectCodeDesc}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ),
              )}
            </ul>
          </div>
        ) : (
          <InfoUnavailable />
        )}
      </div>
    </div>
  );
});

LactationPrecautions.propTypes = {
  lactationPrecautions: PropTypes.object.isRequired,
};

LactationPrecautions.displayName = 'LactationPrecautions';

export default LactationPrecautions;
